// Template HTML pour la modale embedded

import { I18nStrings } from '../../i18n';

export function createModalTemplate(i18n: I18nStrings): string {
  return `
    <div class="flipcard-modal-overlay">
      <div class="flipcard-modal">
        <div class="flipcard-modal-header">
          <h2 class="flipcard-modal-title">${i18n.insertImage}</h2>
          <button class="flipcard-modal-close" data-action="close">
            <i class="mdi mdi-close"></i>
          </button>
        </div>

        <div class="flipcard-modal-body">
          <div class="flipcard-modal-field">
            <label class="flipcard-modal-label">${i18n.uploadFile}</label>
            <div class="flipcard-modal-file-input">
              <label class="flipcard-modal-file-label">
                <i class="mdi mdi-cloud-upload"></i>
                <span data-text="file-label">${i18n.insertImage}</span>
                <input type="file" data-field="file" accept="image/*" />
              </label>
            </div>
            <div class="flipcard-modal-error" data-error="file"></div>
          </div>

          <div class="flipcard-modal-preview" data-preview>
            <img src="" alt="Preview" />
          </div>
        </div>

        <div class="flipcard-modal-footer">
          <button class="flipcard-modal-btn flipcard-modal-btn-cancel" data-action="cancel">
            ${i18n.cancel}
          </button>
          <button class="flipcard-modal-btn flipcard-modal-btn-primary" data-action="submit" disabled>
            ${i18n.ok}
          </button>
        </div>
      </div>
    </div>
  `;
}
